import { ComponentProps } from 'react';
import { DesktopSessionNumber, ParagraphMRegular, ParagraphSRegular, Subtitle1 } from '../../config/designSystem/typography';
import { ISession } from '../../state/stores/Session/SessionModel';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { View } from 'react-native';
import { useStores } from '../../hooks/useStores';



interface SessionCardMainPartProps {
    item: ISession;
    index: number;
    showSummary: boolean;
    date?: string;
    renderSummary: () => React.ReactNode;
    iconColor: string;
    numberColor:string;
  }


export const SessionCardMainPart = ({ item, showSummary, renderSummary, index, numberColor, iconColor, date}: SessionCardMainPartProps) => {
  const rootStore = useStores();
  const labels = rootStore?.language.translate.MOBILE.PATH;

  const renderDuration = () => {
    if (item.duration != null) {
      return (
        <View>
          <ParagraphSRegular
          >
            {String(item.duration)} {labels.MINUTES_LABEL ? labels.MINUTES_LABEL : 'minutes'}
          </ParagraphSRegular>
        </View>
      );
    } else {
      return <></>;
    }
  };

  const renderDate = () => {
    const now = new Date();
    const diffInHour = Math.round((Number(now) - Number(date))/3600000);
    if (date != null) {
      return (
        <View>
          <ParagraphSRegular
          >
            {'Created '}{diffInHour}{' hours ago'}
          </ParagraphSRegular>
        </View>
      );
    } else {
      return <></>;
    }
  };
  const renderLowerPart = () => {
    return (
      <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 5 }}>
        <View style={{ marginRight: 5,  alignSelf:'flex-start' }}>
          {renderIcons()}
          {date? renderDate(): renderDuration()}
        </View>
        <View style={{ marginLeft: 5 }}>{showSummary && renderSummary()}</View>
      </View>
    );
  };

  // one pictogram per KIND of content in the session (exercise, survey,
  // audio, video) rather than one per step: a session of eight text frames
  // used to line up eight identical icons
  type IconName = ComponentProps<typeof MaterialCommunityIcons>['name'];
  const KIND_ICONS: Record<string, IconName> = {
    exercise: 'pencil',
    survey: 'help',
    audio: 'headphones',
    video: 'video',
  };
  const kindOfStep = (step: any): string | null => {
    switch (step?.contentType) {
    case 'CONTENT_AUDIO':
      return 'audio';
    case 'CONTENT_VIDEO':
      return 'video';
    case 'EXERCISE':
      return 'exercise';
    case 'ACTIVITY':
      return step.activity?.type === 'audio' ? 'audio' : 'exercise';
    case 'SURVEY':
    case 'QUESTION':
      return 'survey';
    default:
      // FRAME, CONTENT_TEXT, RADAR: reading, no pictogram
      return null;
    }
  };
  const renderIcons = () => {
    const kinds = Array.from(new Set((item.sessionSteps || []).map(kindOfStep).filter(Boolean))) as string[];
    return (
      <View style={{ flexDirection: 'row' }}>
        {kinds.map(kind => (
          <View key={kind} style={{ marginHorizontal: 2 }}>
            <MaterialCommunityIcons name={KIND_ICONS[kind]} size={16} color={iconColor} />
          </View>
        ))}
      </View>
    );
  };

  const renderNumber= () => {
    return(
      <View style={{alignSelf:'center' }}>
        <DesktopSessionNumber color={numberColor}>
          {index + 1}
        </DesktopSessionNumber>
      </View>
    );
  };
  return(<>
    <View style={{flexDirection:'row', justifyContent:'space-between', alignItems: 'center'}}>
      <View style={{maxWidth:'80%'}}>
        <Subtitle1>
          {item.title}
        </Subtitle1>
      </View>
      {renderNumber()}
    </View>
    <View style={{marginTop:20}}>
      <ParagraphMRegular
      >
        {item.shortDescription}
      </ParagraphMRegular>

    </View>
    {renderLowerPart()}
  </>
  );

};